module.exports = __webpack_public_path__ + "fonts/DM_Sans-700-latin-ext5.cc0d7bc.woff2";